import type { WorkspaceDefinition } from '@/core/ui/workspace'

// ADR-108 (27/10/2026) gom nội dung dự án về nhóm menu «Dự án»; ADR-109 (điều chỉnh 2, cùng ngày, chủ sản phẩm): nhóm còn 3 mục —
// «Thực thi» (ba tab: Của tôi / Cảnh báo / Báo cáo dự án), «Dự án» (sổ đăng ký + chi tiết) và «Chia sẻ ngoài». «Tổng quan» (Gantt 3 năm)
// là thẻ của Hộp công việc và widget Trung tâm điều hành; «Bảng tiến độ» nội bộ và «Cập nhật theo dự án» bỏ (tab WBS & Gantt của chi tiết
// dự án đã làm được); ProgressBoard chỉ còn dùng cho «Chia sẻ ngoài».
const progressBoard = () => import('@/modules/projects/ProgressBoard.vue')

// Của tôi cần WbsNodes.Read (thành viên); Cảnh báo cần Projects.Read; Báo cáo dự án cần Reports.Read — vào mục khi có ít nhất một tab.
export const executionWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'my-work', labelKey: 'menu.projectMyWork', icon: 'pi pi-check-square', permission: 'WbsNodes.Read', component: () => import('@/modules/execution/MyWorkView.vue') },
    { key: 'warnings', labelKey: 'menu.trackingWarnings', icon: 'pi pi-exclamation-triangle', permission: 'Projects.Read', component: () => import('@/modules/execution/ProgressWarningsView.vue') },
    { key: 'reports', labelKey: 'menu.projectReports', icon: 'pi pi-file-edit', permission: 'Reports.Read', component: () => import('@/modules/reports/ProjectReportsTab.vue') },
  ],
}

export const externalWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'customer', labelKey: 'menu.externalCustomer', icon: 'pi pi-users', permission: 'ExternalProgress.ReadCustomer', component: progressBoard, props: { scope: 'customer' } },
    { key: 'subcontractor', labelKey: 'menu.externalSubcontractor', icon: 'pi pi-briefcase', permission: 'ExternalProgress.ReadSubcontractor', component: progressBoard, props: { scope: 'subcontractor' } },
  ],
}
